import { createTeleporter } from 'react-teleporter';

const ActionBar = createTeleporter();

export default ActionBar.Source;
export const ActionBarTarget = ActionBar.Target;
